import z, { literal, object, string, union } from "zod";

export const LoginWithFacebookResponseDTOSuccessLogin = object({
  statusReg: literal("").optional(),
  email: string(),
  login: literal("1"),
  info: string(),
});

export const LoginWithFacebookResponseDTOSuccessRegistration = object({
  statusReg: literal("").optional(),
  email: string(),
  info: string(),
});

export const LoginWithFacebookResponseDTOFailed = object({
  statusReg: string().optional(),
  ex: string(),
});

export const LoginWithFacebookResponseDTO = union([
  LoginWithFacebookResponseDTOSuccessLogin,
  LoginWithFacebookResponseDTOFailed,
  LoginWithFacebookResponseDTOSuccessRegistration,
]);

export type LoginWithFacebookResponseDTO = z.infer<
  typeof LoginWithFacebookResponseDTO
>;
export type LoginWithFacebookResponseDTOSuccessLogin = z.infer<
  typeof LoginWithFacebookResponseDTOSuccessLogin
>;
export type LoginWithFacebookResponseDTOSuccessRegistration = z.infer<
  typeof LoginWithFacebookResponseDTOSuccessRegistration
>;
export type LoginWithFacebookResponseDTOFailed = z.infer<
  typeof LoginWithFacebookResponseDTOFailed
>;
